export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/region', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getRegionList = async (searchText, page, pageLimit, type) => {
    try {
        const result = await get(
            `region?1=1${searchText ? `&search=${searchText}` : ''}${page ? `&page=${page}` : ''}${pageLimit ? `&limit=${pageLimit}` : ''}${type ? `&type=${type}` : ''}`
        );

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getRegionContent = async (newsId) => {
    try {
        const result = await get(`region/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setNewsSeen = async (newsId) => {
    try {
        const result = await put(`region/seen/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createRegion = async (data) => {
    try {
        const result = await post('region', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateNews = async (id, data) => {
    try {
        const result = await put(`region/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteNews = async (id) => {
    try {
        const result = await destroy(`region/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`region/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const subscribeUser = async (id) => {
//     try {
//         const result = await put(`payment/admin/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const getUserCount = async () => {
//     try {
//         const result = await get(`users/count`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
